import React from 'react'
import styled from 'styled-components'
import IconInfo from '../../vectors/IconInfo'
import { Box } from 'rebass'
import typography from '../../utils/typography'
import { bool } from 'prop-types'

const StyledIconInfo = styled(IconInfo)`
  path {
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
    fill: ${(props) => props.theme.colors.grey_light};
  }
  a:hover & path {
    fill: ${(props) =>
      props.secondary ? props.theme.colors.blue : props.theme.colors.grey};
  }
`

const StyledInfoButton = styled.span`
  display: inline-block;
  position: relative;
  top: ${(props) => (props.secondary ? '1px' : '0')};
  z-index: 40;
  margin-right: 5px;
  line-height: 16px;

  a {
    display: inline-block;
    position: relative;
    line-height: inherit;
    color: inherit;

    &::after {
      content: '';
      position: absolute;
      top: -10px;
      right: -10px;
      bottom: -10px;
      left: -10px;
    }
  }

  svg {
    vertical-align: bottom;
    width: 16px;
    height: 16px;
  }
`

const InfoButton = ({ onClick, secondary }) => (
  <StyledInfoButton secondary={secondary}>
    <a href="javascript:void(0)" onClick={onClick} aria-label="Information">
      <StyledIconInfo secondary={secondary} />
    </a>
  </StyledInfoButton>
)

InfoButton.propTypes = {
  secondary: bool
}

const StyledInfoContent = styled(Box)`
  background-color: white;
  position: relative;
  width: 100%;

  p {
    line-height: 1.4;
  }

  table {
    margin-bottom: 0;

    th,
    td {
      padding: 0;
      border-bottom: 0;
    }
    td {
      text-align: right;
    }
  }
`

const InfoContent = ({ items }) => (
  <StyledInfoContent py={typography.rhythm(1.5)} pl={'12%'} pr={'12%'}>
    <p>
      Final quote subject to confirmation of your personal circumstances and
      credit status. Terms & Conditions apply.
    </p>
    {items && (
      <table>
        <tbody>
          {Object.entries(items).map((item, i) => (
            <tr key={`InfoItem${i}`}>
              <th>{item[0]}</th>
              <td>{item[1]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </StyledInfoContent>
)

export { InfoButton, InfoContent, StyledInfoButton }
